import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { environment } from 'src/environments/environment';
import { SpinnerService } from 'src/app/shared/spinner/spinner.service';
import { AdminService } from '../../admin/admin.service'
import { ConnectionService } from '../../organization/connection.service';
import { ConnectionDialogComponent } from 'src/app/shared/dialog/connection-dialog/connection.dialog';
import { MatDialog } from '@angular/material/dialog';
import { PermissionService } from 'src/app/core/services/permission.service';
import { Location } from '@angular/common';
import { ResourcePermissionService } from 'src/app/shared/services/resource-permission.service';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
@Component({
    selector: 'app-workspace-members',
    templateUrl: './workspace-members.component.html',
    styleUrls: ['./workspace-members.component.scss'],
    standalone: false
})
export class WorkspaceMembersComponent implements OnInit {

  workspaceId: any;
  permissions:any = [];
  usersMap:any = {};
  roleMap: any = {};
  selectedRole: any;
  updatePermission: any;
  availableRoles: any = [];
  superAdminRole: any = [];
  existingRoles: any = [];
  selectedRoles: any = [];

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    public workspaceService: WorkspaceService,
    public resourcePermissionServiceService: ResourcePermissionService,
    public spinner: SpinnerService,
    public adminService: AdminService,
    public connectionService: ConnectionService,
    private _dialog: MatDialog,
    public security: PermissionService,
    public authService: AuthServiceService
  ) { }

  ngOnInit(): void {
    this.spinner.hide()
    this.getAllRoles()
    let p = this.route.params.subscribe(params => {
      this.workspaceId = params.workspaceid;
      this.getWorkspacePermissions();

    })
  }
  trackByFn(index:number, item:any):any{
    return item || index
  }

  async getAllRoles(){
    var roles = await this.adminService.listRole(1, 500, this.connectionService.preAuthenticatedToken, {filter: "resource_type=default|string"})
    this.availableRoles = roles.data;
  }

  async getWorkspacePermissions(){
    this.spinner.show();
    var ownerRole = await this.adminService.getOwnerRole();
    var permissions = await this.resourcePermissionServiceService.getPermissions(this.workspaceId);
    // console.log("permissions", permissions);
    var permissionMap = [
      {
        user_id: this.authService.profile._id,
        workspace_id: this.workspaceId,
        resource_type: "workspace",
        resource_id: this.workspaceId,
        status: 'Active',
        created_by: this.authService.profile.email,
        modified_by: this.authService.profile.email,
        roles: [ownerRole._id],
      },
    ];
    permissions = permissionMap.concat(permissions);
    this.permissions = permissions;
    console.log('FINAL PERMISSIONS ARRAY : ', this.permissions);

    var userIds = [];
    var rolesIds = [];
    permissions.forEach(e => {
      userIds.push(e.user_id);
      rolesIds = rolesIds.concat(e.roles);
    })

    var uniqueRoleIds = [];
    rolesIds.forEach((c) => {
      if (!uniqueRoleIds.includes(c)) {
        uniqueRoleIds.push(c);
      }
    });
    console.log("uniqueRoleIds", uniqueRoleIds)

    var roles = await this.adminService.getRolesbyIds(uniqueRoleIds, this.connectionService.preAuthenticatedToken);
    roles.forEach(e => {
      this.roleMap[e._id] = e;
    });

    var users = await this.workspaceService.getUserbyIds(userIds);
    users.forEach(e => {
      this.usersMap[e._id] = e;
    });
    console.log("this.usersMap", this.usersMap)
    console.log("this.roleMap", this.roleMap)

    this.spinner.hide()
  }

  async deleteWorkspacePermission(permissionObj: any) {
    let dialogRef = this._dialog.open(ConnectionDialogComponent, {
      data: { name: "Permission" },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.spinner.show();
        await this,this.resourcePermissionServiceService.deletePermission(permissionObj._id);
        this.spinner.hide();
        this.getWorkspacePermissions();
      }
    })
  }

  setSelectedRole(){
    this.existingRoles = [];
    this.superAdminRole = [];
    this.updatePermission?.roles?.forEach(element => {
      let roleNotMatched = true;
      this.availableRoles.forEach(ele => {
        if(element == ele._id){
          this.existingRoles.push(ele);
          roleNotMatched = false;
        }
      });

      if(roleNotMatched)  this.superAdminRole.push(element);
    });
  }

  selectChangeRoles(event){
    this.selectedRoles = [];
    let data = event?.data || [];
    data.forEach(element => {
      this.selectedRoles.push(element._id);
    });
  }

  async updateResourcePermission(){
    if(this.selectedRoles.length == 0){
      this.updatePermission = undefined
      return;
    }

    var permission = this.updatePermission;
    permission.roles = this.selectedRoles.concat(this.superAdminRole);

    this.spinner.show()
    try {
      await this.resourcePermissionServiceService.updatePermission(permission)
      this.getWorkspacePermissions()
      this.selectedRole = undefined;
      this.updatePermission = undefined
    } catch (error) {
      console.log("Update Permission Failed : ",error)
      this.spinner.hide()
    }
    this.spinner.hide()
  }

  navigateBack(){
    this.location.back();
  }

}
